import { useEffect, useState } from "react";
import { tipoSolicitudCambioCic } from "../../constantes/tipoSolicitudCambioCic";
import servicioCambiosCic from "../../servicios/servicioCambiosCic";
import DatosBasicosPersona from "../Comunes/PersonaUnificada/DatosBasicosPersona";
import SolicitudCambioDeudor from "./CambioDeudor/SolicitudCambioDeudor";
import DocumentosSolicitudCambioCic from "./DetalleSolicitudCambioCic/Secciones/DocumentosSolicitudCambioCic";
import StickyTopBox from "../Comunes/StickyBox/StickyTopBox";
import { Notificar } from "../Comunes/Notificador";
import DetalleSolicitudCambioCic from "./DetalleSolicitudCambioCic/DetalleSolicitudCambioCic";
import ConfirmacionModal from "../Comunes/ConfirmacionModal/ConfirmacionModal";
import servicioBDLocal from "../../servicios/servicioBDLocal";
import servicioUsuario from "../../servicios/servicioUsuario";
import SolicitudCambioCuotasAtrasadas from "./CuotasAtrasadas/SolicitudCambioCuotasAtrasadas";
import SolicitudModificarMotivoLiquidacion from "./MotivoLiquidacion/SolicitudModificarMotivoLiquidacion";
import ServicioComun from "../../servicios/Comun";
import SolicitudIncluirOperacionNoReportada from "./IncluirOperacionNoReportada/SolicitudIncluirOperacionNoReportada";
import SolicitudCambioCodeudor from "./CambioCodeudor/SolicitudCambioCodeudor";
import SolicitudesCuentasPorCobrar from "./CuentasPorCobrar/SolicitudesCuentasPorCobrar";
import SolicitudEliminarOperacion from "./EliminarOperacion/SolicitudEliminarOperacion";

function SolicitudCambioCic({ entidad, tipoSolicitud, deudor, operaciones }) {
  const [datosSolicitud, setDatosSolicitud] = useState(null);
  const [resultadoSolicitud, setResultadoSolicitud] = useState(null);
  const [mostrarModalCancelarSolicitud, setMostrarModalCancelarSolicitud] =
    useState(false);
  const [idUsuario, setIdUsuario] = useState();
  const [motivosLiquidacion, setMotivosLiquidacion] = useState([]);

  useEffect(() => {
    async function obtenerUsuario() {
      const usuario = await servicioUsuario.obtenerUsuarioDelSistema();
      setIdUsuario(usuario.identificacion);
    }

    obtenerUsuario();
  }, []);

  useEffect(() => {
    async function obtenerMotivos() {
      const motivos = await ServicioComun.ObtengaTiposMotivoLiquidacion();
      setMotivosLiquidacion(motivos);
    }

    obtenerMotivos();
  }, []);

  useEffect(() => {
    async function cargarDatosSolicitud() {
      if (!idUsuario) return;

      const solicitudEnBDLocal = await servicioBDLocal.getData(
        servicioBDLocal.Stores.SolicitudesCambioCicEnConstruccion,
        idUsuario
      );

      if (solicitudEnBDLocal) {
        setDatosSolicitud(solicitudEnBDLocal);
        return;
      }

      cargarDatosIniciales();
    }

    function cargarDatosIniciales() {
      const datosIniciales = {
        entidad: entidad,
        tipoSolicitudCambio: tipoSolicitud,
        deudor: deudor.identificacionPrincipal,
        datosDeudor: deudor,
        operaciones: operaciones,
        justificacion: "",
        accionesCorrectivas: "",
        documentos: [],
      };
      setDatosSolicitud(datosIniciales);
    }

    cargarDatosSolicitud();
  }, [idUsuario, entidad, tipoSolicitud, deudor, operaciones]);

  useEffect(() => {
    function guardarSolicitudEnBDLocal() {
      idUsuario &&
        servicioBDLocal.addOrUpdateData(
          servicioBDLocal.Stores.SolicitudesCambioCicEnConstruccion,
          { ...datosSolicitud, idUsuario: idUsuario }
        );
    }

    guardarSolicitudEnBDLocal();
  }, [datosSolicitud, idUsuario]);

  function handleInputChange(e) {
    const { name, value } = e.target;
    setDatosSolicitud((prevData) => ({ ...prevData, [name]: value }));
  }

  function actualizarDatosEspecificosPorTipoDeSolicitud(datos) {
    setDatosSolicitud((prevData) => ({ ...prevData, ...datos }));
  }

  function actualizarDocumentos(documentos) {
    setDatosSolicitud((prevData) => ({ ...prevData, documentos: documentos }));
  }

  async function crearSolicitud() {
    const resultado = await servicioCambiosCic.registrarSolicitudCambioCic(
      datosSolicitud
    );

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    if (resultado.esValido && resultado.detalleSolicitudCambio == null) {
      NoSePudoCargaDetalle(resultado.mensaje);
      return;
    }

    setResultadoSolicitud(resultado);
    eliminarSolicitudEnBDLocal();
    Notificar("success", resultado.mensaje);
  }

  function cancelarSolicitud() {
    eliminarSolicitudEnBDLocal();
    refrescarPagina();
  }

  async function eliminarSolicitudEnBDLocal() {
    servicioBDLocal.deleteData(
      servicioBDLocal.Stores.SolicitudesCambioCicEnConstruccion,
      idUsuario
    );
  }

  function refrescarPagina() {
    window.location.reload(true);
  }

  function NoSePudoCargaDetalle(mensaje) {
    eliminarSolicitudEnBDLocal();
    window.location.reload(true);
    Notificar("success", mensaje);
  }

  if (!datosSolicitud) {
    return null;
  }

  return (
    <>
      {!resultadoSolicitud ? (
        <>
          <StickyTopBox>
            <div className="d-sm-flex align-items-center justify-content-between">
              <h1 className="h3 mb-0 text-gray-800">
                {servicioCambiosCic.obtenerNombreSolicitudCambioCic(
                  datosSolicitud.tipoSolicitudCambio
                )}
              </h1>
              <div>
                <button
                  className="btn btn-success btn-icon-split mr-3"
                  onClick={crearSolicitud}
                >
                  <span className="icon text-white-50">
                    <i className="far fa-check-circle"></i>
                  </span>
                  <span className="text">Crear Solicitud</span>
                </button>

                <button
                  className="btn btn-danger btn-icon-split"
                  onClick={() => setMostrarModalCancelarSolicitud(true)}
                >
                  <span className="icon text-white-50">
                    <i className="far fa-times-circle"></i>
                  </span>
                  <span className="text">Cancelar</span>
                </button>
                <ConfirmacionModal
                  isOpen={mostrarModalCancelarSolicitud}
                  onClose={() => setMostrarModalCancelarSolicitud(false)}
                  onConfirm={cancelarSolicitud}
                  mensaje="¿Eliminar la solicitud?"
                />
              </div>
            </div>
          </StickyTopBox>

          <DatosBasicosPersona
            titulo="Deudor"
            personaUnificada={datosSolicitud.datosDeudor}
          />

          {datosSolicitud.tipoSolicitudCambio ===
          tipoSolicitudCambioCic.TrasladarInformacionCrediticiaDeUnDeudorAOtro ? (
            <SolicitudCambioDeudor
              datosSolicitud={datosSolicitud}
              actualizarDatosTipoSolicitud={
                actualizarDatosEspecificosPorTipoDeSolicitud
              }
            />
          ) : null}

          {datosSolicitud.tipoSolicitudCambio ===
          tipoSolicitudCambioCic.ModificarOEliminarCuotasAtrasadas ? (
            <SolicitudCambioCuotasAtrasadas
              datosSolicitud={datosSolicitud}
              actualizarDatosTipoSolicitud={
                actualizarDatosEspecificosPorTipoDeSolicitud
              }
            />
          ) : null}

          {datosSolicitud.tipoSolicitudCambio ===
          tipoSolicitudCambioCic.ModificarOEliminarCuentasPorCobrarAsociadas ? (
            <SolicitudesCuentasPorCobrar
              datosSolicitud={datosSolicitud}
              actualizarDatosTipoSolicitud={
                actualizarDatosEspecificosPorTipoDeSolicitud
              }
            />
          ) : null}

          {datosSolicitud.tipoSolicitudCambio ===
          tipoSolicitudCambioCic.ModificarMotivoDeLiquidacion ? (
            <SolicitudModificarMotivoLiquidacion
              datosSolicitud={datosSolicitud}
              actualizarDatosTipoSolicitud={
                actualizarDatosEspecificosPorTipoDeSolicitud
              }
              motivosLiquidacion={motivosLiquidacion}
            />
          ) : null}

          {datosSolicitud.tipoSolicitudCambio ===
          tipoSolicitudCambioCic.IncluirMotivoDeLiquidacion ? (
            <SolicitudIncluirOperacionNoReportada
              datosSolicitud={datosSolicitud}
              actualizarDatosTipoSolicitud={
                actualizarDatosEspecificosPorTipoDeSolicitud
              }
            />
          ) : null}

          {datosSolicitud.tipoSolicitudCambio ===
          tipoSolicitudCambioCic.ExcluirOSustituirCodeudor ? (
            <SolicitudCambioCodeudor
              datosSolicitud={datosSolicitud}
              actualizarDatosTipoSolicitud={
                actualizarDatosEspecificosPorTipoDeSolicitud
              }
            />
          ) : null}

          {datosSolicitud.tipoSolicitudCambio ===
          tipoSolicitudCambioCic.EliminarOperacion ? (
            <SolicitudEliminarOperacion
              datosSolicitud={datosSolicitud}
              actualizarDatosTipoSolicitud={
                actualizarDatosEspecificosPorTipoDeSolicitud
              }
            />
          ) : null}

          <div className="card shadow mb-4">
            <div className="card-header">
              <h6 className="m-0 font-weight-bold text-primary">
                Justificación y Acciones Correctivas
              </h6>
            </div>
            <div className="card-body">
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="justificacion">Justificación</label>
                  <textarea
                    id="justificacion"
                    name="justificacion"
                    className="form-control"
                    rows="5"
                    value={datosSolicitud.justificacion}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="accionesCorrectivas">
                    Acciones Correctivas
                  </label>
                  <textarea
                    id="accionesCorrectivas"
                    name="accionesCorrectivas"
                    className="form-control"
                    rows="5"
                    value={datosSolicitud.accionesCorrectivas}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <DocumentosSolicitudCambioCic
            documentos={datosSolicitud.documentos}
            actualizarDocumentos={actualizarDocumentos}
            permiteAgregar="true"
            permiteEliminar="true"
          />
        </>
      ) : null}

      {resultadoSolicitud ? (
        <>
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray-800">
              Resultado de la Solicitud de Modificación
            </h1>
            <button
              className="btn btn-primary btn-icon-split"
              onClick={refrescarPagina}
            >
              <span className="icon text-white-50">
                <i className="fas fa-plus-circle"></i>
              </span>
              <span className="text">Nueva Solicitud</span>
            </button>
          </div>
          {resultadoSolicitud &&
          resultadoSolicitud.detalleSolicitudCambio != null ? (
            <DetalleSolicitudCambioCic
              detalleSolicitud={resultadoSolicitud.detalleSolicitudCambio}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default SolicitudCambioCic;
